import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import {
  ContactAddDialogContainer,
  ContactEditDialogContainer
} from 'bank-contacts/src/containers/ContactMetadataManage'
import { z } from 'zod'

export const contactAddEditSearch = z.object({
  contactName: z.string().optional()
})

export const detailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$id`,
    component: lazyRouteComponent(() => import('./CompanyDetails'))
  })

export const contactAddRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    validateSearch: (search) => contactAddEditSearch.parse(search),
    getParentRoute: () => indexRoute,
    path: `$id/contact/add/$contactId`,
    component: ContactAddDialogContainer
  })

export const contactEditRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    validateSearch: (search) => contactAddEditSearch.parse(search),
    getParentRoute: () => indexRoute,
    path: `$id/contact/edit/$contactId`,
    component: ContactEditDialogContainer
  })
